export const LOAD_ONLINE_USERS = 'users/LOAD';
export const USER_JOIN = 'users/JOIN';
export const USER_LEAVE = 'users/LEAVE';
export const CHANGE_USERNAME = 'users/CHANGE_USERNAME';
export const USER_ADD_ROLES = 'users/ADD_ROLES';
export const USER_REMOVE_ROLES = 'users/REMOVE_ROLES';

export const RECEIVE_GUEST_COUNT = 'users/RECEIVE_GUEST_COUNT';

export const DO_CHANGE_USERNAME_START = 'users/DO_CHANGE_USERNAME_START';
export const DO_CHANGE_USERNAME_COMPLETE = 'users/DO_CHANGE_USERNAME_COMPLETE';
